(function unitOrgComboControlModuleDefinition() {
    'use strict';

    angular.module('UnitOrgComboControl', [])
        .directive('crUnitOrgComboControl', ['$translate', 'organizationalUnitService', 'errorsExtend',
            function ($translate, organizationalUnitService, errors) {
                return {
                    scope:
                    {
                        unitOrgId: '=',
                        labelName: '@',
                        allOu: '@',
                        unitOrgNotInId: '=',
                        selectedOu: "=ngModel",
                        parentfun: '&',
                        placeholder: '@',
                        emptyOu: '&',
                        ngChange: '&',
                        hasDefaultValue: '=',
                        onlyChildOus: '='
                    },

                    controller: [
                        '$scope', '$element', 'storageService', function ($scope, $element, storageService) {
                            $scope.organizationalUnits = [];

                            organizationalUnitService.getOuTReeControl().then(function getOk(result) {

                                if ($scope.onlyChildOus) {
                                    result = result.filter(function (ou) { return !ou.isRoot} );
                                }

                                $scope.organizationalUnits = result;
                                $scope.disabledControl = result.length === 1;
                                var storedOU = storageService.getOrganizationalUnitFilter();
                                if (storedOU) {
                                    if ($scope.hasDefaultValue || $scope.hasDefaultValue === undefined) {
                                        for (var i = 0; i < result.length; i++) {
                                            if (result[i].id == storedOU.id) {
                                                $scope.selectedOu = { id: result[i].id, name: result[i].name };
                                            }
                                        }
                                    } else {
                                        if (result.length == 1) {
                                            $scope.selectedOu = { id: result[0].id, name: result[0].name };
                                        }
                                        else {
                                            $scope.organizationalUnits.unshift({ name: "" });
                                            $scope.selectedOu = undefined;
                                        }
                                    }
                                } else {
                                    if (!$scope.emptyOu() || $scope.disabledControl) {
                                        $scope.selectedOu = result.filter(function (ou) { return ou.id === $scope.unitOrgId; })[0];

                                        if ($scope.selectedOu === undefined) {
                                            $scope.selectedOu = result[0];
                                        }
                                    } else {
                                        $scope.organizationalUnits.unshift({ name: "ALL" });
                                        $scope.selectedOu = $scope.organizationalUnits[0];
                                    }
                                }

                            }, function getError(error) {
                                errors.showError(error);
                            });
                        }],

                    templateUrl: '/app/directives/unit-org-combo-control/unit-org-combo-control.html',
                    link: function () {
                    }
                };
            }
        ]);
})();